export default name => () => import(`../views/${name}.vue`);



// WEBPACK FOOTER //
// ./src/router/lazyLoading.js